"use strict";

(function () {
  'use strict';

  function ConnectionModalCtrl() {
    var vm = this;

    this.connect = function () {
      this.close({
        $event: 'ok'
      });
    };

    this.cancel = function () {
      this.dismiss({
        $event: 'cancel button clicked'
      });
    };
  }

  ConnectionModalCtrl.$inject = [];
  angular.module('connection-modal', []).component('connectionModal', {
    bindings: {
      partner: '<',
      close: '&',
      dismiss: '&'
    },
    controller: ConnectionModalCtrl,
    templateUrl: 'components/connection-modal/connection-modal.html'
  });
})();